module.exports = __webpack_public_path__ + "static/media/4.aed3df24.jpg";